import dayjs from 'dayjs';
import 'dayjs/locale/th';
import numeral from 'numeral';

import buddhistEra from 'dayjs/plugin/buddhistEra';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';

dayjs.extend(buddhistEra);

const CardHNoneImage = ({ data, large = false, description = false, eventDataLayer }) => {
  const dateUpdate = dayjs(data.published_at).locale('th').format('DD MMM BBBB เวลา H:mm น.');

  return (
    <a
      href={data?.link}
      className='card-wrapper'
      //! DATALAYER
      onClick={() => sendDataLayerGlobal({ ...eventDataLayer })}
    >
      <div className='card-h --preview'>
        <div className='card-h-pageview'>{data?.pageviews !== null && <span className='badge'>{numeral(data.pageviews).format('0.0a')}</span>}</div>
        <div className={`card-h-content ${large ? '--large' : ''}`}>
          <h3 className='card-h-content-title text-excerpt-2'>{data.title}</h3>
          {/* <div className='card-h-content-meta mt-1'>
            <AiOutlineClockCircle />
            <span>{dateUpdate}</span>
          </div> */}
          {description && <p className='text-excerpt-3'>{data.blurb}</p>}
        </div>
      </div>
    </a>
  );
};
export default CardHNoneImage;
